import type { AbstractSingleFilterPillsProps } from '@hotjar/global-filters';
import { GenericRadioFilter } from '@hotjar/global-filters';
import { useTranslation } from '@hotjar/translations';
import {
  HAS_EMAIL_FILTER_OPTIONS,
  HAS_EMAIL_TYPE,
  isAllResponsesEmailFilterValue,
} from './HasEmailType';

const PRIMARY_LABELS: Record<HAS_EMAIL_TYPE, string> = {
  [HAS_EMAIL_TYPE.ANY]: 'any-value',
  [HAS_EMAIL_TYPE.YES]: 'yes-value',
  [HAS_EMAIL_TYPE.NO]: 'no-value',
};

export function HasEmailFilter({
  currentValue,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  isInactive,
}: AbstractSingleFilterPillsProps<HAS_EMAIL_TYPE>): JSX.Element {
  const { t } = useTranslation('feedback', {
    keyPrefix: 'feedback-responses.filters.has-email',
  });
  const isAllResponsesSelected = isAllResponsesEmailFilterValue(currentValue);

  const optionsTranslated = HAS_EMAIL_FILTER_OPTIONS.map((option) => ({
    ...option,
    label: t(option.label),
  }));

  return (
    <GenericRadioFilter
      filterName={t('user-email')}
      iconName="boolean"
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={optionsTranslated}
      label1={isAllResponsesSelected ? '' : t('value-selected-label')}
      label2={currentValue ? t(PRIMARY_LABELS[currentValue]) : t('user-email')}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      isInactive={isInactive}
      showDropdownCaret
    />
  );
}
